// valentine slider js start
$(document).ready(function () {

  $('.block__valentine-wrapper').each(function () {
    const $section = $(this);
    const $top = $section.find('.block__valentine-slick-top-image');
    const $bottom = $section.find('.block__valentine-slick-bottom-images');

    if (!$top.length || !$bottom.length) return;
    if ($top.hasClass('slick-initialized')) return;

    $top.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      fade: true,
      asNavFor: $bottom
    });

    $bottom.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: true,
      arrows: false,
      infinite: true,
      centerMode: true, 
      asNavFor: $top,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5
          }
        }
      ]
    });
  });

});
// valentine slider js end

// choose-valentine.js
// document.addEventListener('DOMContentLoaded', function () {

//   document.querySelectorAll('.block__valentine-choose-main').forEach(section => {

//     const buttons   = section.querySelectorAll('.tab-btn');
//     const contents  = section.querySelectorAll('.tab-content');
//     const bgBlocks  = section.querySelectorAll('.block__backgrond--custom-wrapper');
//     const $wrapper  = jQuery(section).find('.tab-content-wrapper');

//     /* ---- INITIAL DESKTOP STATE ---- */
//     if (window.innerWidth >= 750) {
//       contents.forEach((content, i) => {
//         content.classList.toggle('is-active', i === 0);
//         content.classList.toggle('is-inactive', i !== 0);
//       });

//       bgBlocks.forEach((block, i) => {
//         block.classList.toggle('active', i === 0);
//       });
//     }

//     /* ---- TAB CLICK ---- */
//     buttons.forEach((button, index) => {
//       button.addEventListener('click', function () {

//         buttons.forEach(btn => btn.classList.remove('active'));
//         this.classList.add('active');

//         /* 📱 MOBILE → SLIDE */
//         if (window.innerWidth < 750 && $wrapper.hasClass('slick-initialized')) {
//           $wrapper.slick('slickGoTo', index);

//           bgBlocks.forEach((block, i) => {
//             block.classList.toggle('active', i === index);
//           });

//           return;
//         }

//         /* 💻 DESKTOP → OPACITY */
//         contents.forEach((content, i) => {
//           if (i === index) {
//             content.classList.add('is-active');
//             content.classList.remove('is-inactive');

//             jQuery(content)
//               .find('.block__valentine-slick-top-image, .block__valentine-slick-bottom-images')
//               .slick('setPosition');
//           } else {
//             content.classList.remove('is-active');
//             content.classList.add('is-inactive');
//           }
//         });

//         bgBlocks.forEach((block, i) => {
//           block.classList.toggle('active', i === index);
//         });
//       });
//     });

//     /* =========================================
//        PER-PRODUCT IMAGE SLICK (KEEP THIS)
//     ========================================= */
//     jQuery(section).find('.valentine-product').each(function () {
//       const $product = jQuery(this);
//       const $top = $product.find('.block__valentine-slick-top-image');
//       const $bottom = $product.find('.block__valentine-slick-bottom-images');

//       if (!$top.length || !$bottom.length) return;
//       if ($top.hasClass('slick-initialized')) return;

//       $top.slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         fade: true,
//         asNavFor: $bottom
//       });

//       $bottom.slick({
//         slidesToShow: 5,
//         slidesToScroll: 1,
//         focusOnSelect: true,
//         arrows: false,
//         infinite: false,
//         asNavFor: $top,
//         responsive: [
//           {
//             breakpoint: 768,
//             settings: {
//               slidesToShow: 5
//             }
//           }
//         ]
//       });
//     });

//   });

// });

document.addEventListener('DOMContentLoaded', () => {

  /* ================= CONFIG ================= */
  const BREAKPOINT = 750;
  const SCROLL_DURATION_TAB = 1000;
  const SCROLL_DURATION_CAPTION = 1500;
  const EXTRA_GAP = 12;

  /* ================= RAF HANDLES ================= */
  let tabScrollRAF = null;
  let captionScrollRAF = null;

  /* ================= EASING ================= */
  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* ================= SMOOTH SCROLL (TAB) ================= */
  function smoothScrollTab(targetY) {
    if (tabScrollRAF) cancelAnimationFrame(tabScrollRAF);

    const startY = window.pageYOffset;
    const diff = targetY - startY;
    let startTime = null;

    function step(time) {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / SCROLL_DURATION_TAB, 1);

      window.scrollTo(0, startY + diff * easeInOutCubic(progress));

      if (progress < 1) tabScrollRAF = requestAnimationFrame(step);
    }

    tabScrollRAF = requestAnimationFrame(step);
  }

  /* ================= SMOOTH SCROLL (CAPTION) ================= */
  function smoothScrollCaption(targetY) {
    if (captionScrollRAF) cancelAnimationFrame(captionScrollRAF);

    const startY = window.pageYOffset;
    const diff = targetY - startY;
    let startTime = null;

    function step(time) {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / SCROLL_DURATION_CAPTION, 1);

      window.scrollTo(0, startY + diff * easeInOutCubic(progress));

      if (progress < 1) captionScrollRAF = requestAnimationFrame(step);
    }

    captionScrollRAF = requestAnimationFrame(step);
  }

  /* ================= GET TARGET Y (DYNAMIC HEADER) ================= */
  function getTargetY(el) {
    const header = document.querySelector('#SiteHeader');
    const headerHeight = header
      ? Math.round(header.getBoundingClientRect().height)
      : 0;

    return (
      el.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight -
      EXTRA_GAP
    );
  }

  /* ================= MOBILE WRAPPER SLICK ================= */
  function initTabContentMobileSlick() {
    $('.tab-content-wrapper').each(function () {
      const $wrapper = $(this);

      if (window.innerWidth < BREAKPOINT) {
        if (!$wrapper.hasClass('slick-initialized')) {
          $wrapper.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: true
          });
        }
      } else {
        if ($wrapper.hasClass('slick-initialized')) {
          $wrapper.slick('unslick');
        }
      }
    });
  }

  initTabContentMobileSlick();
  window.addEventListener('resize', initTabContentMobileSlick);

  /* ================= MAIN SECTION ================= */
  document.querySelectorAll('.block__valentine-choose-main').forEach(section => {

    const buttons  = section.querySelectorAll('.tab-btn');
    const contents = section.querySelectorAll('.tab-content');
    const bgBlocks = section.querySelectorAll('.block__backgrond--custom-wrapper');
    const $wrapper = $(section).find('.tab-content-wrapper');
    const scrollEl = section.querySelector('.block__backgrond--heading-custom');

    /* ---------- ACTIVE STATE ---------- */
    function setActiveState(index) {
      buttons.forEach((btn, i) => btn.classList.toggle('active', i === index));

      contents.forEach((content, i) => {
        content.classList.toggle('is-active', i === index);
        content.classList.toggle('is-inactive', i !== index);

        if (i === index) {
          $(content).find('.slick-initialized').slick('setPosition');
        }
      });

      bgBlocks.forEach((b, i) => b.classList.toggle('active', i === index));
    }

    setActiveState(0);

    /* ---------- TAB CLICK ---------- */
    buttons.forEach((btn, index) => {
      btn.addEventListener('click', () => {

        const targetY = getTargetY(scrollEl);

        if (window.innerWidth < BREAKPOINT && $wrapper.hasClass('slick-initialized')) {
          // 📱 Mobile: start BOTH together
          $wrapper.slick('slickGoTo', index);
          smoothScrollTab(targetY);

        } else {
          // 💻 Desktop
          smoothScrollTab(targetY);
        }

        setActiveState(index);
      });
    });

    /* ---------- SWIPE → TAB SYNC ---------- */
    if ($wrapper.length) {
      $wrapper.on('afterChange', (_, __, current) => {
        if (window.innerWidth < BREAKPOINT) {
          setActiveState(current);
        }
      });
    }

    /* ================= PRODUCT IMAGE SLICKS ================= */
    $(section).find('.valentine-product').each(function () {

      const $product = $(this);
      const $top = $product.find('.block__valentine-slick-top-image');
      const $bottom = $product.find('.block__valentine-slick-bottom-images');

      if (!$top.length || !$bottom.length) return;
      if ($top.hasClass('slick-initialized')) return;

      $top.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: $bottom
      });

      $bottom.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: $top,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 5 } }
        ]
      });
    });

  });

  /* ================= CAPTION SCROLL ================= */
  document.querySelectorAll('.block__section-caption').forEach(caption => {
    caption.addEventListener('click', e => {
      e.preventDefault();

      const target =
        caption.closest('.block__valentine-choose-main') ||
        document.querySelector('.block__valentine-choose-main');

      if (!target) return;

      smoothScrollCaption(getTargetY(target));
    });
  });

  /* ================= QUICK ADD LOADER ================= */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.wd-quick-add-to-cart .add-to-cart');
    if (!btn || btn.classList.contains('btn--loading')) return;

    btn.classList.add('btn--loading');
    setTimeout(() => btn.classList.remove('btn--loading'), 1500);
  });

});

/* ===== Sticky Add To Cart bar (mobile) ===== */
(function(){
if(!/\/products\//.test(window.location.pathname)) return;
function init(){
var form=document.querySelector('form[action*="/cart/add"]');
if(!form) return;
var realBtn=form.querySelector('button[name="add"]');
if(!realBtn||document.getElementById('sticky-atc-bar')) return;
var titleEl=document.querySelector('.product-single__title, .product__title, h1');
var priceEl=document.querySelector('.product__price, .price-item--regular');
var ogm=document.querySelector('meta[property="og:image"]');var imgEl=ogm?{src:ogm.getAttribute('content'),currentSrc:ogm.getAttribute('content')}:null;
var bar=document.createElement('div');
bar.id='sticky-atc-bar';
var imgHtml=imgEl?'<img class="sab-img" src="'+(imgEl.currentSrc||imgEl.src)+'" alt="">':'';
bar.innerHTML=imgHtml+'<div class="sab-info"><div class="sab-title">'+(titleEl?titleEl.textContent.trim():'')+'</div><div class="sab-price">'+(priceEl?priceEl.textContent.trim():'')+'</div></div><button type="button" class="sab-btn">DODAJ U KO\u0160ARICU</button>';
document.body.appendChild(bar);
bar.querySelector('.sab-btn').addEventListener('click',function(){realBtn.click();});
var ticking=false;
function check(){
ticking=false;
var r=realBtn.getBoundingClientRect();
var visible=r.bottom>0&&r.top<(window.innerHeight||document.documentElement.clientHeight);
if(visible){bar.classList.remove('is-visible');}else{bar.classList.add('is-visible');}
}
function onScroll(){if(!ticking){ticking=true;window.requestAnimationFrame(check);}}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll,{passive:true});
check();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

/* ===== Sold-out products to bottom of collection grids ===== */
(function(){function sob(){if(!/\/collections\//.test(window.location.pathname))return;var grids=document.querySelectorAll('.grid--uniform');grids.forEach(function(g){var items=Array.prototype.slice.call(g.children).filter(function(c){return c.classList&&c.classList.contains('grid-product');});items.forEach(function(it){if(it.querySelector('.grid-product__tag--sold-out'))g.appendChild(it);});});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sob);}else{sob();}})();